module.exports = __webpack_public_path__ + "static/brochure-c4f5acef00f3bbf619e1002744e94fa5.png";